import React, { useState, useCallback } from "react";
import './BuffElement.css';

function ToolTip({ position, buff, remainingTime }) {
    if (!position) return null;
    
    return (
        <div 
            className="tooltip" 
            style={{ 
                left: `${position.x}px`, 
                top: `${position.y}px`,
                position: 'fixed'
            }}
        >
            <h3>{buff.name}</h3>
            {buff.description.split('<br>').map((text, index) => (
                <p key={index}>{text}</p>
            ))}
            {remainingTime !== -1 && (
                <span className="tooltip-time">[{formatFullTime(remainingTime)}]</span>
            )}
        </div>
    );
}

function BuffElement({ buff, remainingTime }) {
    const [tooltipPosition, setTooltipPosition] = useState(null);

    const handleMouseMove = useCallback((e) => {
        if (!tooltipPosition) {
            // Position tooltip above the mouse pointer if near the bottom of the screen
            const nearBottomEdge = window.innerHeight - e.clientY < 150;
            
            setTooltipPosition({ 
                x: Math.min(e.clientX + 15, window.innerWidth - 220), // Prevent going off right edge
                y: nearBottomEdge ? e.clientY - 15 : e.clientY + 20
            });
        }
    }, [tooltipPosition]);

    const handleMouseLeave = useCallback(() => {
        setTooltipPosition(null);
    }, []);

    const timeDisplay = remainingTime !== -1 ? formatBuffTime(remainingTime) : null;
    const isLowTime = remainingTime !== -1 && remainingTime < 60000; // Less than 1 minute

    return (
        <div className="buff">
            <div
                onMouseMove={handleMouseMove}
                onMouseLeave={handleMouseLeave}
            >
                <img 
                    className='buff-pic' 
                    src={require('../../Assets/gfx/' + buff.picId + '.webp')}  
                    alt={buff.name} 
                />
            </div>
            <p>{buff.shortName}</p>
            {timeDisplay && (
                <span className={`buff-time ${isLowTime ? 'low-time' : ''}`}>
                    [{timeDisplay}]
                </span>
            )}
            <ToolTip 
                position={tooltipPosition}
                buff={buff}
                remainingTime={remainingTime}
            />
        </div>
    );
}

function formatBuffTime(duration) {
    if (duration === -1) return '∞';
    
    const minutes = Math.floor(duration / (1000 * 60));
    const seconds = Math.floor((duration % (1000 * 60)) / 1000);
    
    if (minutes >= 1) {
        return `${minutes}m`;
    } else {
        return `${seconds}s`;
    }
}

function formatFullTime(duration) {
    if (duration === -1) return '∞';
    
    const minutes = Math.floor(duration / (1000 * 60));
    const seconds = Math.floor((duration % (1000 * 60)) / 1000);
    
    if (minutes >= 1) {
        return `${minutes}m ${seconds.toString().padStart(2, '0')}s`;
    } else {
        return `${seconds}s`;
    }
}

export default BuffElement;

